import hasOnlyNumbers from '../function/hasOnlyNumbers';

export const isValidRoutingNumber = (value: string) =>
  hasOnlyNumbers(value);
